import { CatalogSection } from './CatalogSection';

export const CompetitionsSection = ({ filterKey }: { filterKey?: string }) => (
  <CatalogSection kind="COMPETITION" filterKey={filterKey} />
);
